import { useCallback } from 'react';

import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import {
  SEARCH_ALERTS_ERROR_TYPE,
  SEARCH_ALERTS_ERROR_BANNER,
} from '@xing-com/crate-jobs-constants';
import { useJobsNwtTracking } from '@xing-com/crate-jobs-tracking';

export const useShowSearchAlertErrorBanner = (
  type: keyof typeof SEARCH_ALERTS_ERROR_TYPE,
  nwtPage?: string
): (() => void) => {
  const { setSearchParameter } = useSearchParameter();
  const trackNwtEvent = useJobsNwtTracking();

  return useCallback(() => {
    trackNwtEvent({
      eventSchema: 'basic',
      event: 'error_shown',
      element: 'search_alert',
      context:
        type === 'DELETE'
          ? 'search_alert_deactivation_error'
          : `search_alert_activation_error${type === 'DUPLICATED' ? '_exists_already' : ''}`,
      page: nwtPage,
    });

    setSearchParameter(
      SEARCH_ALERTS_ERROR_BANNER,
      SEARCH_ALERTS_ERROR_TYPE[type]
    );
  }, [setSearchParameter, trackNwtEvent, type]);
};
